import { render, staticRenderFns } from "./ptTableRowLiveCasino.vue?vue&type=template&id=08956224&lang=pug&"
import script from "./ptTableRowLiveCasino.vue?vue&type=script&lang=js&"
export * from "./ptTableRowLiveCasino.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports